import { render, staticRenderFns } from "./ValoresFaltantesIndex.vue?vue&type=template&id=50375b84"
import script from "./ValoresFaltantesIndex.vue?vue&type=script&lang=js"
export * from "./ValoresFaltantesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports